import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'styles/index.scss';
import { RouterProvider } from "react-router-dom";
import { router } from "routes";
import { Provider } from "react-redux";
import store from "store";
import reportWebVitals from 'reportWebVitals';
import { WebsocketsProvider } from 'hook/useWebsockets';
import { platforms } from 'utils/environment.util';
import MatomoTagManager from 'analytics/matomo';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
  
root.render(
  <Provider store={store}>
    <WebsocketsProvider enabled={process.env.REACT_APP_PLATFORM !== platforms.WEB}>
      <MatomoTagManager enabled={process.env.REACT_APP_ENABLE_MATOMO == 'true'}/>
      <RouterProvider router={router} />
    </WebsocketsProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
